<template>
  <div>
    <div class="d-flex justify-center">
      <v-btn
        @click="hideSeries"
        class="mt-4"
        color="warning"
        v-if="hideSeriesDefault"
      >
        Отключить все
      </v-btn>
    </div>
    <apexchart
      type="line"
      :options="chartOptions"
      :series="chartSeries"
      height="400"
      ref="chart_"
    />
  </div>
</template>

<script>
export default {
  props: {
    chartXData: {
      type: Array,
      required: true,
      default: () => [],
    },
    chartYData: {
      type: Array,
      required: true,
      default: () => [],
    },
    straightLine: {
      type: Boolean,
      required: false,
      default: false,
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
    yTitle: {
      type: String,
      required: false,
      default: '',
    },
    hideSeriesDefault: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  methods: {
    hideSeries() {
      this.chartYData.forEach(el => {
        this.$refs.chart_.hideSeries(el.name)
      })
    }
  },
  computed: {
    chartOptions() {
      return {
        chart: {
          zoom: {
            enabled: false,
          },
        },
        title: {
          text: this.title ? this.title : '',
        },
        xaxis: {
          type: "string",
          categories: this.chartXData,
        },
        yaxis: {
          title: {
            text: this.yTitle ? this.yTitle : '',
          },
        },
        legend: {
          position: "right",
          horizontalAlign: "left",
        },
        stroke: {
          curve: this.straightLine ? "straight" : "smooth",
        },
      };
    },
    chartSeries() {
      if (this.hideSeriesDefault) {
        this.chartYData.forEach(el => {
          el.hidden = true;
        })
      }
      return this.chartYData;
    },
  },
};
</script>
